import { takeLatest, call, put, all } from 'redux-saga/effects';
import { errorMessage } from '~/utils/Message';

import api from '~/services/api';

import { signInSuccess, signInFailure } from './actions';

export function* signIn({ payload }) {
  try {
    const { register, password } = payload;

    const response = yield call(api.post, 'sessions', {
      register,
      password,
    });

    const { token, user } = response.data;

    if (user.role.id > 1) {
      api.defaults.headers.Authorization = `Bearer ${token}`;

      yield put(signInSuccess(token, user));
    } else {
      errorMessage('Unauthorized');
      yield put(signInFailure());
    }
  } catch (error) {
    errorMessage(error);
    yield put(signInFailure());
  }
}

export function setToken({ payload }) {
  if (!payload) return;

  const { token } = payload.auth;

  if (token) {
    api.defaults.headers.Authorization = `Bearer ${token}`;
  }
}

export function signOut() {}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest('@auth/SIGN_IN_REQUEST', signIn),
  takeLatest('@auth/SIGN_OUT', signOut),
]);
